import React, { useState } from "react";
import MuiTextField, { TextFieldProps } from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

import { IconButton } from "components/IconButton";

const useStyles = makeStyles(theme => ({
  inputRoot: {
    fontSize: theme.typography.fontSize
  },
  formHelperTextRoot: {
    fontSize: "10px",
    margin: theme.spacing(1, 1.5, 0.5, 1.5)
  }
}));

// See (for variant as any): https://github.com/Microsoft/TypeScript/issues/28791
export const RawTextField: React.FunctionComponent<TextFieldProps> = ({
  margin = "dense",
  variant = "outlined",
  fullWidth = true,
  type = "text",
  disabled = false,
  InputProps,
  ...props
}: TextFieldProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const customClasses = useStyles();

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  if (type === "password") {
    return (
      <MuiTextField
        variant={variant as any}
        margin={margin}
        fullWidth={fullWidth}
        type={showPassword ? "text" : "password"}
        label="Password"
        FormHelperTextProps={{
          classes: { root: customClasses.formHelperTextRoot }
        }}
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={togglePassword}
              >
                {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
          classes: { root: customClasses.inputRoot }
        }}
        InputLabelProps={{ shrink: true }}
        {...props}
      />
    );
  }

  return (
    <MuiTextField
      margin={margin}
      variant={variant as any}
      fullWidth={fullWidth}
      disabled={disabled}
      type={type}
      FormHelperTextProps={{
        classes: { root: customClasses.formHelperTextRoot }
      }}
      InputProps={{ ...InputProps, classes: { root: customClasses.inputRoot } }}
      InputLabelProps={{ shrink: true }}
      {...props}
    />
  );
};
